import React, { useEffect, useState } from 'react';
import { getQrCode } from '../../../../Service';
import { Button, Col, Row, InputGroup, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from "@fortawesome/free-solid-svg-icons";

export default function QRCodeGenerate() {

    const [shopQRCode, setShopQRCode] = useState('');
    const [shopURL, setShopURL] = useState('');
    const [individualQRCode, setIndividualQRCode] = useState('');
    const [individualURL, setIndividualURL] = useState('');
    const [shopCopied, setShopCopied] = useState(false);
    const [individualCopied, setIndividualCopied] = useState(false);

    useEffect(() => {
        getQrCode().then(res => qrcodeResponseHandle(res));
    }, []);

    const qrcodeResponseHandle = ( res ) => {

        if ( res.data.statusCode === 200 ) {
            setShopQRCode(res.data.shopQrCodeBase64);
            setShopURL(res.data.shopUrl);
            setIndividualQRCode(res.data.individualQrCodeBase64);
            setIndividualURL(res.data.individualUrl);
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: res.data.statusMessage,
                timer: 3000
            }); 
        }
    }

    const downloadQRCode = ( type ) => {
        if ( type === 'shop' && shopQRCode ) {

            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${shopQRCode}`;
            link.download = 'shop-QR-Code.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else if ( type === 'individual' && individualQRCode ) {

            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${individualQRCode}`;
            link.download = 'individual-QR-Code.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Oops...',
                showConfirmButton: false,
                text: 'Something went wrong, Please try after sometimes.',
                timer: 3000
            }); 
        }
    }

    const copyURLHandle = ( type ) => {
        navigator.clipboard.writeText(type === 'shop' ? shopURL : individualURL).then(() => {
            
            if ( type === 'shop' ) {
                setShopCopied(true);
            } else {
                setIndividualCopied(true);
            }

            setTimeout(() => {
                if ( type === 'shop' ) {
                    setShopCopied(false);
                } else {
                    setIndividualCopied(false);
                }
            }, 1000);
        })
    }

    return(
        <Row>
            <Col>
                <h4 className='mb-3'>QR Code Download</h4>
                {
                    shopQRCode && individualQRCode ?   
                        <Row className="mb-3">
                            <Col md='6'> 
                                <p className='marginIncreace'>QR code for shop</p>
                                <div className='qrImage'>
                                    <img src={"data:image/jpeg;base64," + shopQRCode} alt='QR-Image' style={{width : '50%'}}/>
                                    <div className='qrDownloadBtn'>
                                        <Button variant="primary" className='upload-btn' style={{marginTop : '0'}} onClick={() => downloadQRCode('shop')}>Download</Button>
                                    </div>
                                </div>
                                <InputGroup className='copyURL'>
                                    <Form.Control value={shopURL} readOnly />
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip id="button-tooltip-2">Copy</Tooltip>}
                                    >
                                        <Button variant="outline-secondary" onClick={() => copyURLHandle('shop')}>
                                            <FontAwesomeIcon icon={shopCopied ? faCheck : faCopy}/>
                                        </Button>
                                    </OverlayTrigger>
                                </InputGroup>
                            </Col>
                            <Col md='6'>
                                <p className='marginIncreace'>QR code for individual</p>
                                <div className='qrImage'>
                                    <img src={"data:image/jpeg;base64," + individualQRCode} alt='QR-Image' style={{width : '50%'}}/>
                                    <div className='qrDownloadBtn'>
                                        <Button variant="primary" className='upload-btn' style={{marginTop : '0'}} onClick={() => downloadQRCode('individual')}>Download</Button>
                                    </div>
                                </div>
                                <InputGroup className='copyURL'>
                                    <Form.Control value={individualURL} readOnly />
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip id="button-tooltip-2">Copy</Tooltip>}
                                    >
                                        <Button variant="outline-secondary" onClick={() => copyURLHandle('individual')}>
                                            <FontAwesomeIcon icon={individualCopied ? faCheck : faCopy}/>
                                        </Button>
                                    </OverlayTrigger>
                                </InputGroup>
                            </Col>
                        </Row>
                    :
                        <Row>
                            <Col>
                                <p className='payoutValid'><span>Something went wrong, Please try after sometimes.</span></p>
                            </Col>
                        </Row>
                }
            </Col>
            
        </Row>
    )
}